import Vue from 'vue';
import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';

import store from '../store';
import * as constants from '../utils/constants';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../pages/Home.vue'),
    },
    {
        path: '/profile',
        name: 'auth.profile',
        component: () => import('../pages/auth/Profile.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/workspace',
        name: 'workspace',
        component: () => import('../pages/Workspace.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/login',
        name: 'auth.login',
        component: () => import('../pages/auth/Login.vue'),
        meta: {
            guest: true,
        },
    },
    {
        path: '/register',
        name: 'auth.register',
        component: () => import('../pages/auth/Register.vue'),
        meta: {
            guest: true,
        },
    },
    {
        path: '/password/reset',
        name: 'auth.password.email',
        component: () => import('../pages/auth/PasswordEmail.vue'),
        meta: {
            guest: true,
        },
    },
    {
        path: '/password/reset/:token',
        name: 'auth.reset.password',
        component: () => import('../pages/auth/ResetPassword.vue'),
        meta: {
            guest: true,
        },
    },
    {
        path: '/courses',
        name: 'course.courses',
        component: () => import('../pages/course/Courses.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/courses/add',
        name: 'course.add',
        component: () => import('../pages/course/AddCourse.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/courses/:id/update',
        name: 'course.update',
        component: () => import('../pages/course/UpdateCourse.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/courses/:id/progress',
        name: 'course.progress',
        component: () => import('../pages/course/ProgressCourse.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/course/:course_id/lesson/:lesson_id/progress/:user_id',
        name: 'lesson.progress',
        component: () => import('../pages/lesson/ProgressLesson.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/certificates',
        name: 'certificate.certificates',
        component: () => import('../pages/certificate/Certificates.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/lessons',
        name: 'lesson.lessons',
        component: () => import('../pages/lesson/Lessons.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/lessons/add/:id?',
        name: 'lesson.add',
        component: () => import('../pages/lesson/AddLesson.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/lesson/:id/update',
        name: 'lesson.update',
        component: () => import('../pages/lesson/UpdateLesson.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/badges',
        name: 'badge.badges',
        component: () => import('../pages/badge/Badges.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/topics',
        name: 'topic.topics',
        component: () => import('../pages/topic/Topics.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/topic/add',
        name: 'topic.add',
        component: () => import('../pages/topic/AddTopic.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/topic/:id/update',
        name: 'topic.update',
        component: () => import('../pages/topic/UpdateTopic.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/quizzes',
        name: 'quiz.quizzes',
        component: () => import('../pages/quiz/Quizzes.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/quizzes/add',
        name: 'quiz.add',
        component: () => import('../pages/quiz/AddQuiz.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/quizzes/:id/update',
        name: 'quiz.update',
        component: () => import('../pages/quiz/UpdateQuiz.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/questions',
        name: 'question.questions',
        component: () => import('../pages/question/Questions.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/questions/add',
        name: 'question.add',
        component: () => import('../pages/question/AddQuestion.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/questions/:id/update',
        name: 'question.update',
        component: () => import('../pages/question/UpdateQuestion.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/ads',
        name: 'ad.ads',
        component: () => import('../pages/ad/Ads.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/ads/add',
        name: 'ad.add',
        component: () => import('../pages/ad/AddAd.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/ads/:id/update',
        name: 'ad.update',
        component: () => import('../pages/ad/UpdateAd.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/news',
        name: 'news.news',
        component: () => import('../pages/news/News.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/news/add',
        name: 'news.add',
        component: () => import('../pages/news/AddNews.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/news/:id/update',
        name: 'news.update',
        component: () => import('../pages/news/UpdateNews.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/users/managers',
        name: 'manager.list',
        component: () => import('../pages/user/manager/List.vue'),
        meta: {
            admin: true,
        },
    },
    {
        path: '/users/managers/:id/update',
        name: 'manager.update',
        component: () => import('../pages/user/Form.vue'),
        meta: {
            admin: true,
        },
    },
    {
        path: '/users/managers/create',
        name: 'manager.create',
        component: () => import('../pages/user/Form.vue'),
        meta: {
            admin: true,
        },
    },
    {
        path: '/users/teachers',
        name: 'teacher.list',
        component: () => import('../pages/user/teacher/List.vue'),
        meta: {
            manager: true,
        },
    },
    {
        path: '/users/teachers/:id/update',
        name: 'teacher.update',
        component: () => import('../pages/user/Form.vue'),
        meta: {
            manager: true,
        },
    },
    {
        path: '/users/teachers/create',
        name: 'teacher.create',
        component: () => import('../pages/user/Form.vue'),
        meta: {
            manager: true,
        },
    },
    {
        path: '/users/students',
        name: 'student.list',
        component: () => import('../pages/user/student/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/users/students/:id/update',
        name: 'student.update',
        component: () => import('../pages/user/Form.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/users/students/create',
        name: 'student.create',
        component: () => import('../pages/user/Form.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/schools',
        name: 'school.list',
        component: () => import('../pages/school/List.vue'),
        meta: {
            admin: true,
        },
    },
    {
        path: '/schools/:id/update',
        name: 'school.update',
        component: () => import('../pages/school/Form.vue'),
        meta: {
            admin: true,
        },
    },
    {
        path: '/schools/create',
        name: 'school.create',
        component: () => import('../pages/school/Form.vue'),
        meta: {
            admin: true,
        },
    },
    {
        path: '/schools/courses',
        name: 'school.courses',
        component: () => import('../pages/school/Courses.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/email/finish/course',
        name: 'email.finish.course',
        component: () => import('../pages/email/FinishCourse.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/email/finish/lesson',
        name: 'email.finish.lesson',
        component: () => import('../pages/email/FinishLesson.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/email/enroll/course',
        name: 'email.enroll.course',
        component: () => import('../pages/email/StartCourse'),
        meta: {
            auth: true,
        },
    },
    /**
     * Must be the last entry in array.
     */
    {
        path: '*',
        component: () => import('../pages/NotFound.vue'),
    },
];

const router = new VueRouter({
    routes,
    mode: 'hash',
    linkActiveClass: 'active',
    scrollBehavior() {
        return {
            x: 0,
            y: 0,
        };
    },
});

// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.auth) && !store.getters['auth/logged']) {
//         /**
//          * If the user is not authenticated and visits
//          * a page that requires authentication, redirect to the login page
//          */
//         next({
//             name: 'auth.login',
//             query: {
//                 redirect: to.fullPath,
//             },
//         });
//     } else if (to.matched.some(record => record.meta.guest) && store.getters['auth/logged']) {
//         /**
//          * If the user is authenticated and visits
//          * an guest page, redirect to the homepage
//          */
//         next({
//             name: 'home',
//         });
//     } else {
//         next();
//     }
// });

router.beforeEach((to, from, next) => {
    if (store.getters['auth/logged']) {
        /**
         * If the user is authenticated
         */
        if (window.Cookies.get('type') !== constants.COOKIE_TYPE_ADMIN) {
            window.location.replace(`${window.location.protocol}//${window.location.hostname}`);
        } else if (to.matched.some(record => record.meta.admin)) {
            next();
        } else if (to.matched.some(record => record.meta.admin) && Number(store.getters['auth/roleId']) !== constants.USER_ROLE_ADMIN) {
            /**
             * If authenticated user visits teachers page or page that requires authentication
             */
            next({
                name: 'home',
            });
        } else if (to.matched.some(record => record.meta.manager)) {
            /**
             * If authenticated user visits managers page
             */
            if (Number(store.getters['auth/roleId']) === constants.USER_ROLE_TEACHER) {
                /**
                 * If authenticated the user is teacher, redirect to the homepage
                 */
                next({
                    name: 'home',
                });
            } else {
                /**
                 * If authenticated user is admin or manager
                 */
                next();
            }
        } else if (to.matched.some(record => record.meta.guest)) {
            /**
             * If the user is authenticated and visits
             * an guest page, redirect to the homepage
             */
            next({
                name: 'home',
            });
        } else {
            next();
        }
    } else {
        /**
         * If the user is not authenticated
         */
        if (to.matched.some(record => record.meta.guest) || Object.keys(to.meta).length === 0) {
            next();
        } else {
            /**
             * If not authenticated user visits any page except guests,
             * redirect to login
             */
            next({
                name: 'auth.login',
                query: {
                    redirect: to.fullPath,
                },
            });
        }
    }
});


sync(store, router);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js